/* * @Author: 孙福聪 * @Date: 2019-01-16 16:02:43 * @Last Modified by: 孙福聪 * @Last Modified time:
2019-03-26 16:03:37 */
<template lang="pug">
  .teacher-home
    .top-nav
      .nav-box.clear-fix
        .left-nav.clear-fix
          .left-item.logoImg(@click="changePage(0)")
            img(:src='logoNav')
          .left-item(@click="isChange = !isChange")
            span {{productData.product}}
            span.triangle(v-if="casePowerState")
            div.selectBlock(:class="isChange ? 'active' : '' ",v-if="casePowerState")
              div.TypeLine
                img(:src='logoNav')
                span {{productData.product}}
              div.TypeLine(@click="gotuAnalysis")
                img(:src='logoNav')
                span {{productData.newProduct}}
          .left-item(v-for='(item, index) of leftNav',:class="{'nav-focus': pageIndex === index}"
            :key="index",@click="changePage(index)") {{item.name}}
          //- .left-item(v-for='(item, index) of leftNavadmin',:class="{'nav-focus': pageIndex === index}"
            //- :key="index",@click="changePage(index)" v-if="this.$role.role === 'admin'") {{item.name}}
        .right-nav
          Tooltip(trigger="hover" content="通知" placement="bottom" :disabled="isNotice")
            div(v-if="!unreadList || userInfo.type === 'student'").notice
              i.icon-msg.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont(@click="isNotice = !isNotice;query();")
                  //- 新添加通知功能,通过区分type来进行不同操作识别
                  ul.notice-menu(:class="isNotice ? 'active' : '' ")
                    li.notice-tag 通知
                    li.news-tag(@click='fun_go(x);query();')
                        i.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont
                        div.type
                          div.title-tag 暂无消息
                    li.cover(@click='$router.push("/Teacher/notice");pageIndex=-1;query();') 查看全部
            Badge(v-else dot).notice
              i.icon-msg.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont(@click="isNotice = !isNotice;query();")
                //- 新添加通知功能,通过区分type来进行不同操作识别
                ul.notice-menu(:class="isNotice ? 'active' : '' ")
                  li.notice-tag 通知
                  li.news-tag(v-for='(x,index) in unreadList',v-if='index<=0',@click='fun_go(x);query();')
                      i.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont
                      div(v-if='x.type==="老师评分"').type
                        div.title-tag {{JSON.parse(x.content).notifyTheBoxContent}}
                        div.time {{x.createdTime}}
                      div(v-if='x.type==="老师审核自定义案例"').type
                        div.title-tag 您有新的案例待审核
                        div.time {{x.createdTime}}
                      div(v-if='x.type==="密码重置提示"').type
                        div.title-tag 密码重置提示
                        div.time {{x.createdTime}}
                      div(v-if='x.type==="分享资料"').type
                        div.title-tag 您有新的分享资料
                        div.time {{x.createdTime}}
                      div(v-if='x.type==="分享案例"').type
                        div.title-tag 您有新的分享案例
                        div.time {{x.createdTime}}
                  li.cover(@click='$router.push("/Teacher/notice");pageIndex=-1;query();') 查看全部
            //- i.icon-msg.iconfont.icon-manual-install(@click='fun_switch')
            //- 通过isShow控制点击是否弹出
          Tooltip(trigger="hover" content="个人设置" placement="bottom" :disabled="isShow").personalOption
            .user
                img.avatar(:src='userInfo.src' @click="isShow = !isShow")
                //- 添加了div达到hover和点击的效果
            .blockbox(@click="isShow = !isShow") {{userInfo.name}}
              .user-menu(:class="isShow ? 'active' : '' ")
                .personal-center(style="margin-top: 4px;" @click="go('个人中心')")
                  Icon(type="ios-person-outline" size="20")
                  span 个人中心
                //- div(style="width:120px;height:1px;background:rgba(210,221,236,1);")
                .change-system(v-if="userInfo.type !== 'admin'" @click='fun_switch' style="margin-bottom: 4px;")
                  Icon(type="md-swap" size="20")
                  span 切换窗口
                div(v-if="userInfo.type !== 'admin'" style="width:120px;height:1px;background:rgba(210,221,236,1);")
                .logout(style="margin-top: 4px;margin-bottom: 4px;" @click="go('注销')")
                  Icon(type="ios-log-out" size="20")
                  span 退出账号
      div.mask(v-show='isNotice' :class="isNotice ? 'active' : '' " @click="isNotice = !isNotice")
      div.mask(v-show='isShow' :class="isShow ? 'active' : '' " @click="isShow = !isShow")
      div.mask(v-show='isDelete' :class="isDelete ? 'active' : '' " @click="changeDelete")
      div.mask(v-show='isChange' :class="isChange ? 'active' : '' " @click="isChange = !isChange")
</template>
<script>
import MyBus from "@/utils/main";
import axios from "axios";
import dayjs from "dayjs";
export default {
  data() {
    return {
      productData: {
        newProduct: "",
        product: ""
      },
      Unread: "",
      hash: "",
      pageIndex: 0,
      isShow: false,
      isNotice: false,
      isDelete: false,
      isChange: false,
      leftNav: [
        { name: "用户管理", path: "/Teacher/userlist" },
        { name: "班级管理", path: "/Teacher/classlist" },
        { name: "实验管理", path: "/Teacher/experimentManage" },
        { name: "报告管理", path: "/Teacher/reportManage" },
        { name: "资料中心", path: "/Teacher/datacenter" },
        { name: "自定义", path: "/Teacher/case" },
        { name: "审核", path: "/Teacher/To_examine" }
      ],
      userInfo: {
        src: "",
        name: "",
        type: ""
      },
      list: [],
      unreadList: []
    };
  },
  watch: {
    $route() {
      this.changepath();
    },
    pageIndex(newval) {
      sessionStorage.setItem("teacherPageIndex", newval);
    }
  },
  methods: {
    gotuAnalysis() {
      if (this.casePower.includes("analysis")) {
        window.location.href = "/policy/analysis.html";
      }
    },
    changepath() {
      console.log(this.$route.path);
      switch (this.$route.path) {
        case "/Teacher/userlist":
          if (this.$role.role === "admin") {
            this.pageIndex = 0;
          }
          break;
        case "/Teacher/classlist":
          if (this.$role.role === "admin") {
            this.pageIndex = 1;
            break;
          }
          this.pageIndex = 0;
          break;
        case "/Teacher/experimentManage":
          if (this.$role.role === "admin") {
            this.pageIndex = 2;
            break;
          }
          this.pageIndex = 1;
          break;
        case "/Teacher/reportManage":
        case "/Teacher/reportManage2":
          if (this.$role.role === "admin") {
            this.pageIndex = 3;
            break;
          }
          this.pageIndex = 2;
          break;
        case "/Teacher/datacenter":
          if (this.$role.role === "admin") {
            this.pageIndex = 4;
            break;
          }
          this.pageIndex = 3;
          break;
        case "/Teacher/case":
          if (this.$role.role === "admin") {
            this.pageIndex = 5;
            break;
          }
          this.pageIndex = 4;
          break;
        case "/Teacher/To_examine":
          this.pageIndex = 5;
          break;
        default:
          break;
      }
      sessionStorage.setItem("pageIndex", this.pageIndex);
    },
    fun_go(x) {
      console.log(x);
      console.log(this.$role.role);
      console.log("this", this);
      switch (x.type) {
        case "老师评分":
          this.$router.push("/Teacher/reportManage");
          this.$parent.$refs.topNav.pageIndex = 2;
          sessionStorage.setItem("pageIndex", 2);
          this.checkReaded(x);
          this.query();
          break;
        case "老师审核自定义案例":
          this.$router.push("/Teacher/To_examine");
          this.$parent.$refs.topNav.pageIndex = 5;
          sessionStorage.setItem("pageIndex", 5);
          this.checkReaded(x);
          this.query();
          break;
        case "分享资料":
          if (this.$role.role === "admin") {
            this.$parent.$refs.topNav.pageIndex = 4;
            sessionStorage.setItem("pageIndex", 4);
            this.$router.push("/Teacher/datacenter");
            this.checkReaded(x);
            this.query();
            break;
          }
          if (this.$role.role === "teacher") {
            this.$parent.$refs.topNav.pageIndex = 3;
            sessionStorage.setItem("pageIndex", 3);
            this.$router.push("/Teacher/datacenter");
            this.checkReaded(x);
            this.query();
          }
          break;
        case "分享案例":
          if (this.$role.role === "admin") {
            this.$parent.$refs.topNav.pageIndex = 5;
            sessionStorage.setItem("pageIndex", 5);
            this.$router.push("/Teacher/case");
            this.checkReaded(x);
            this.query();
            break;
          }
          if (this.$role.role === "teacher") {
            this.$parent.$refs.topNav.pageIndex = 4;
            sessionStorage.setItem("pageIndex", 4);
            this.$router.push("/Teacher/case");
            this.checkReaded(x);
            this.query();
          }
          break;
        default:
          break;
      }
    },
    fun_switch() {
      this.$router.push({
        path: "/Student/home"
      });
    },
    go(path) {
      let pathStr = "";
      if (path === "注销") {
        pathStr = "/";
        if (sessionStorage.getItem("isCAS")) {
          window.open("./api/user/login/out/cas");
          sessionStorage.removeItem("isCAS");
        }

        sessionStorage.removeItem("token");
      } else if (path === "个人中心") {
        pathStr = "/Teacher/personalCenter";
      }
      this.$router.push({
        path: pathStr
      });
    },
    changePage(index) {
      if (this.pageIndex === index) {
        return false;
      }
      this.pageIndex = index;
      sessionStorage.setItem("pageIndex", this.pageIndex);
      this.$router.push({ path: this.leftNav[index].path });
    },
    getByCode() {
      this.$http
        .userInfo({ code: this.$role.code })
        .then(res => {
          // 新增对登录账户属性的判断,针对管理员教师学生做出type类型判断
          if (res.data.success) {
            console.log(res);
            this.userInfo.name = res.data.data.name;
            this.userInfo.src = res.data.data.headImagePath;
            if (res.data.data.admin === true) {
              this.userInfo.type = "admin";
              this.query();
            } else if (res.data.data.student === true) {
              this.userInfo.type = "student";
              this.query();
            } else if (res.data.data.teacher === true) {
              this.userInfo.type = "teacher";
              this.query();
            }
            console.log(this.userInfo);
          }
        })
        .catch(() => {
          this.$Message.error("服务器异常");
        });
    },
    query() {
      // 查询未读通知个数
      const adminData = {
        userId: this.$role.code,
        types: JSON.stringify(["分享资料", "分享案例"])
        // type: "外部通知"
      };
      const adminUnData = {
        isRead: 0,
        userId: this.$role.code,
        types: JSON.stringify(["分享资料", "分享案例"])
      };
      const teacherData = {
        userId: this.$role.code
      };
      const teacherUnData = {
        isRead: 0,
        userId: this.$role.code
      };
      if (this.userInfo.type === "admin") {
        // 管理员未读
        this.$http.queryUnreadnotice(adminData).then(res => {
          if (res.data.success) {
            this.Unread = res.data.data;
          }
        });
        // 管理员信息 查询外部通知
        this.$http.listWithoutNotification(adminUnData).then(res => {
          if (res.data.success) {
            this.list = res.data.data.list;
            this.unreadList = res.data.data.list.map((item) => {
              return {
                ...item,
                createdTime: dayjs(item.createdTime).format("YYYY-MM-DD HH:mm:ss")
              };
            });
          }
        });
      }
      if (this.userInfo.type === "teacher") {
        // 教师未读
        this.$http.queryUnreadnotice(teacherData).then(res => {
          if (res.data.success) {
            this.Unread = res.data.data;
            console.log(this.Unread);
          }
        });
        // 教师信息 查询外部通知
        this.$http.listWithoutNotification(teacherData).then(res => {
          console.log(res);
        });
        this.$http.listWithoutNotification(teacherUnData).then(res => {
          if (res.data.success) {
            this.list = res.data.data.list;
            this.unreadList = res.data.data.list.map((item) => {
              return {
                ...item,
                createdTime: dayjs(item.createdTime).format("YYYY-MM-DD HH:mm:ss")
              };
            });
          }
        });
      }
      // 查询登陆信息
      this.$forceUpdate();
    },
    checkReaded(x) {
      // 变为已读状态
      const data = {
        ids: [x.id]
      };
      data.ids = JSON.stringify(data.ids);
      this.$http.updateNotificationRead(data).then(res => {
        console.log(res);
      });
      this.query();
    },
    changeDelete() {
      this.isDelete = !this.isDelete;
      MyBus.$emit("isDelete", this.isDelete);
    },
    getProductName() {
      axios.get("./static/product_name.json").then(res => {
        this.productData = res.data;
      });
    }
  },
  computed: {
    casePowerState() {
      return this.casePower.includes("analysis");
    },
    casePower() {
      return this.$store.state.Case.pattern;
    }
  },
  created() {
    this.getProductName();
    this.getByCode();
    this.query();
  },
  mounted() {
    MyBus.$on("getByCode", () => {
      this.getByCode();
    });
    MyBus.$on("fun_notice", () => {
      this.query();
    });
    MyBus.$on("msg", e => {
      this.userInfo.name = e.name;
      this.userInfo.src = e.headImagePath;
    });
    MyBus.$on("change_mask", () => {
      this.isDelete = !this.isDelete;
      MyBus.$emit("isDelete", this.isDelete);
    });
    if (this.$role.role !== "admin") {
      this.leftNav.splice(0, 1);
    }
    if (this.$role.role === "admin") {
      this.leftNav.splice(6, 1);
    }
    this.getByCode();
    this.hash = this.$route.path;
    for (let i = 0; i < this.leftNav.length; i++) {
      if (this.leftNav[i].path === this.hash) {
        this.pageIndex = i;
        break;
      } else {
        this.pageIndex = -1;
      }
    }
    this.changepath();

    // this.pageIndex = +sessionStorage.getItem("pageIndex");
  }
};
</script>

<style lang="stylus" scope>
@keyframes fade-in
  from
    height 0
  to
    height 128px
@keyframes fade-out
  from
    height 128px
  to
    height 0
.teacher-home
  .top-nav
    position absolute
    top 0
    left 0
    right 0
    background #ffffff
    height 60px
    z-index 100
    min-width 1360px
    .nav-box
      // width 1128px
      height @height
      margin 0 auto
      margin-left 93px
      margin-right 109px
      // margin-left 144px
      .left-nav
        float left
        .left-item
          float left
          height @height
          line-height @height
          color #2A2E36
          font-size 14px
          min-width 86px
          cursor pointer
          text-align center
          &:nth-child(2)
            font-size 14px
            font-family MicrosoftYaHeiUI
            color rgba(42, 46, 54, 1)
            line-height 60px
            margin-left 8px
            margin-right 48px
            width auto
            position relative
          .triangle
            width 0
            height 0
            border-style solid
            box-sizing border-box
            border-width 5px
            border-color #000000 transparent transparent transparent
            position absolute
            top 28px
            right -15px
          .selectBlock
            width max-content
            height 80px
            background rgba(255,255,255,1)
            box-shadow 0px 0px 6px 0px rgba(0,0,0,0.2)
            border-radius 4px
            position absolute
            bottom -85px
            right -30px
            padding 4px 0
            display none
            &.active
              display block
              z-index 999
            .TypeLine
              width 100%
              height 36px
              line-height 36px
              cursor pointer
              &:hover
                background rgba(245,245,245,1)
              &:first-child
                background rgba(245,245,245,1)
                color #2D8CF0
              img
                width 24px
                height 18px
                vertical-align middle
                margin 9px 10px 0 16px
                float left
              span
                float left
                padding-right: 12px;
        .nav-focus
          color #3A76D2
          border-bottom 2px solid
        .logoImg
          line-height @height
          min-width 24px
          max-width 24px
          img
            width 24px
            // height 18px
            vertical-align middle
      .right-nav
        float right
        box-sizing border-box
        // padding-right 69px
        font-size 14px
        height @height
        line-height @height
        color #2A2E36
        .ivu-tooltip
          .notice
            .ivu-badge-dot
              top 15px
              right 8px
          .ivu-tooltip-popper
            &:nth-child(2)
              // left 1150px !important
          .iconfont
            font-size 24px
            display inline-block
            margin-left 24px
            margin-right 24px
            cursor pointer
            color #2A2E36
            position relative
            // &:hover .notice-menu
            // display block
            .notice-menu
              position absolute
              display none
              z-index 999
              background rgba(255, 255, 255, 1)
              box-shadow 0px 2px 4px 0px rgba(0, 0, 0, 0.3)
              border-radius 8px
              right -140px
              width 300px
              // height 160px
              &.active
                display block
                z-ndex 999
              .notice-tag
                font-size 14px
                font-family MicrosoftYaHeiUI
                color rgba(42, 46, 54, 1)
                height 48px
                line-height 48px
                // margin-left 16px
              .news-tag
                line-height 1em
                background rgba(246, 250, 254, 1)
                box-shadow 0px -1px 0px 0px rgba(128, 128, 128, 0.2)
                border-bottom 1px solid rgba(128, 128, 128, 0.2)
                height 72px
              .iconfont
                float left
                font-size 24px
                color #508ff4
                margin 16px 11px 0 16px
              .title-tag
                text-align left
                font-size 14px
                font-family MicrosoftYaHeiUI
                color #2a2e36
                padding-top 10px
                display -webkit-box
                -webkit-box-orient vertical
                -webkit-line-clamp 2
                overflow hidden
              .time
                text-align left
                font-size 12px
                font-family MicrosoftYaHeiUI
                color #808080
                padding-top 5px
                padding-left 52px
            .cover
              font-size 12px
              font-family MicrosoftYaHeiUI
              color rgba(53, 126, 212, 1)
              text-align center
              position relative
              height 30px
              line-height 30px
              // top -12px
        .personalOption
          position relative
          top -4px
          .ivu-tooltip-popper
            left -25px !important
        .user
          // width 125px
          display inline-block
          cursor pointer
          // &:hover
          // .user-menu
          // display block
          img
            width 32px
            height 32px
            border-radius 30%
            vertical-align middle
            margin-right 10px
            margin-bottom 7px
        .blockbox
          text-align right
          display inline-block
          position relative
          // font-size 16px
          color #2A2E36
          // &:hover .user-menu
          // display block
          .user-menu
            display none
            cursor pointer
            position absolute
            // right 20px
            top 60px
            left -50px
            color #979797
            background #fff
            width 122px
            text-align center
            z-index 100
            border-radius 5px
            border 1px solid #dddddd78
            box-shadow 0px 2px 4px 0px rgba(0, 0, 0, 0.3)
            div
              height 36px
              line-height @height
              &:hover
                background #eef2f5
              span
                font-size 14px
                color rgba(42, 46, 54, 1)
              i
                padding-right 8px
            &.active
              display block
              z-index 999
    .fade-out
      animation fade-out 1s forwards
    .fade-in
      animation fade-in 1s forwards
    .mask
      &.active
        display block
        width 100vw
        height 100vh
        position fixed
        top 0
        left 0
        z-index 900
</style>
